const USER_ACTIONS_TYPES = {
  POST_USER_LOGIN: "POST_USER_LOGIN",
  POST_USER_LOGIN_SUCCESS: "POST_USER_LOGIN_SUCCESS",
  POST_USER_LOGIN_FAIL: "POST_USER_LOGIN_FAIL",
  // =====================================
  POST_USER_SIGNUP: "POST_USER_SIGNUP",
  POST_USER_SIGNUP_SUCCESS: "POST_USER_SIGNUP_SUCCESS",
  POST_USER_SIGNUP_FAIL: "POST_USER_SIGNUP_FAIL",
  // =====================================
  POST_USER_LOGOUT: "POST_USER_LOGOUT",
  POST_USER_LOGOUT_SUCCESS: "POST_USER_LOGOUT_SUCCESS",
  POST_USER_LOGOUT_FAIL: "POST_USER_LOGOUT_FAIL",
  // =====================================
  GET_USER: "GET_USER",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_FAIL: "GET_USER_FAIL",
};
const CHEMICAL_ACTIONS_TYPES = {
  POST_CHEMICAL: "POST_CHEMICAL",
  POST_CHEMICAL_SUCCESS: "POST_CHEMICAL_SUCCESS",
  POST_CHEMICAL_FAIL: "POST_CHEMICAL_FAIL",
  // =====================================
  GET_CHEMICAL: "GET_CHEMICAL",
  GET_CHEMICAL_SUCCESS: "GET_CHEMICAL_SUCCESS",
  GET_CHEMICAL_FAIL: "GET_CHEMICAL_FAIL",
  // =====================================
  PUT_CHEMICAL: "PUT_CHEMICAL",
  PUT_CHEMICAL_SUCCESS: "PUT_CHEMICAL_SUCCESS",
  PUT_CHEMICAL_FAIL: "PUT_CHEMICAL_FAIL",
  // =====================================
  DELETE_CHEMICAL: "DELETE_CHEMICAL",
  DELETE_CHEMICAL_SUCCESS: "DELETE_CHEMICAL_SUCCESS",
  DELETE_CHEMICAL_FAIL: "DELETE_CHEMICAL_FAIL",
  // =====================================
  CLEAR_CHEMICAL: "CLEAR_CHEMICAL",
  CLEAR_CHEMICAL_SUCCESS: "CLEAR_CHEMICAL_SUCCESS",
  CLEAR_CHEMICAL_FAIL: "CLEAR_CHEMICAL_FAIL",
};
const CHEMICALS_ACTIONS_TYPES = {
  GET_CHEMICALS: "GET_CHEMICALS",
  GET_CHEMICALS_SUCCESS: "GET_CHEMICALS_SUCCESS",
  GET_CHEMICALS_FAIL: "GET_CHEMICALS_FAIL",
};

const TOOLS_ACTIONS_TYPES = {
  GET_TOOLS: "GET_TOOLS",
  GET_TOOLS_SUCCESS: "GET_TOOLS_SUCCESS",
  GET_TOOLS_FAIL: "GET_TOOLS_FAIL",
};
const TOOL_ACTIONS_TYPES = {
  POST_TOOL: "POST_TOOL",
  POST_TOOL_SUCCESS: "POST_TOOL_SUCCESS",
  POST_TOOL_FAIL: "POST_TOOL_FAIL",
  // =====================================
  GET_TOOL: "GET_TOOL",
  GET_TOOL_SUCCESS: "GET_TOOL_SUCCESS",
  GET_TOOL_FAIL: "GET_TOOL_FAIL",
  // =====================================
  PUT_TOOL: "PUT_TOOL",
  PUT_TOOL_SUCCESS: "PUT_TOOL_SUCCESS",
  PUT_TOOL_FAIL: "PUT_TOOL_FAIL",
  // =====================================
  DELETE_TOOL: "DELETE_TOOL",
  DELETE_TOOL_SUCCESS: "DELETE_TOOL_SUCCESS",
  DELETE_TOOL_FAIL: "DELETE_TOOL_FAIL",
  // =====================================
  CLEAR_TOOL: "CLEAR_TOOL",
  CLEAR_TOOL_SUCCESS: "CLEAR_TOOL_SUCCESS",
  CLEAR_TOOL_FAIL: "CLEAR_TOOL_FAIL",
  // =====================================
};
const EXPERIMENTS_ACTIONS_TYPES = {
  GET_EXPERIMENTS: "GET_EXPERIMENTS",
  GET_EXPERIMENTS_SUCCESS: "GET_EXPERIMENTS_SUCCESS",
  GET_EXPERIMENTS_FAIL: "GET_EXPERIMENTS_FAIL",
};
const EXPERIMENT_ACTIONS_TYPES = {
  POST_EXPERIMENT: "POST_EXPERIMENT",
  POST_EXPERIMENT_SUCCESS: "POST_EXPERIMENT_SUCCESS",
  POST_EXPERIMENT_FAIL: "POST_EXPERIMENT_FAIL",
  // =====================================
  GET_EXPERIMENT: "GET_EXPERIMENT",
  GET_EXPERIMENT_SUCCESS: "GET_EXPERIMENT_SUCCESS",
  GET_EXPERIMENT_FAIL: "GET_EXPERIMENT_FAIL",
  // =====================================
  PUT_EXPERIMENT: "PUT_EXPERIMENT",
  PUT_EXPERIMENT_SUCCESS: "PUT_EXPERIMENT_SUCCESS",
  PUT_EXPERIMENT_FAIL: "PUT_EXPERIMENT_FAIL",
  // =====================================
  DELETE_EXPERIMENT: "DELETE_EXPERIMENT",
  DELETE_EXPERIMENT_SUCCESS: "DELETE_EXPERIMENT_SUCCESS",
  DELETE_EXPERIMENT_FAIL: "DELETE_EXPERIMENT_FAIL",
  // =====================================
  CLEAR_EXPERIMENT: "CLEAR_EXPERIMENT",
  CLEAR_EXPERIMENT_SUCCESS: "CLEAR_EXPERIMENT_SUCCESS",
  CLEAR_EXPERIMENT_FAIL: "CLEAR_EXPERIMENT_FAIL",
  // =====================================
  POST_TOOL_IMAGE: "POST_TOOL_IMAGE",
  POST_TOOL_IMAGE_SUCCESS: "POST_TOOL_IMAGE_SUCCESS",
  POST_TOOL_IMAGE_FAIL: "POST_TOOL_IMAGE_FAIL",
  // =====================================
  POST_DEVICE_IMAGE: "POST_DEVICE_IMAGE",
  POST_DEVICE_IMAGE_SUCCESS: "POST_DEVICE_IMAGE_SUCCESS",
  POST_DEVICE_IMAGE_FAIL: "POST_DEVICE_IMAGE_FAIL",
  // =====================================
  DELETE_TOOL_IMAGE: "DELETE_TOOL_IMAGE",
  DELETE_TOOL_IMAGE_SUCCESS: "DELETE_TOOL_IMAGE_SUCCESS",
  DELETE_TOOL_IMAGE_FAIL: "DELETE_TOOL_IMAGE_FAIL",
  // =====================================
  DELETE_DEVICE_IMAGE: "DELETE_DEVICE_IMAGE",
  DELETE_DEVICE_IMAGE_SUCCESS: "DELETE_DEVICE_IMAGE_SUCCESS",
  DELETE_DEVICE_IMAGE_FAIL: "DELETE_DEVICE_IMAGE_FAIL",
  // =====================================
  SET_DEVICE_DIMENSIONS: "SET_DEVICE_DIMENSIONS",
  SET_TOOL_DIMENSIONS: "SET_TOOL_DIMENSIONS",
  SET_TOOL_POSITION: "SET_TOOL_POSITION",
};
export {
  USER_ACTIONS_TYPES,
  CHEMICAL_ACTIONS_TYPES,
  CHEMICALS_ACTIONS_TYPES,
  TOOLS_ACTIONS_TYPES,
  TOOL_ACTIONS_TYPES,
  EXPERIMENTS_ACTIONS_TYPES,
  EXPERIMENT_ACTIONS_TYPES,
};
